import type { ProblemCard } from '../types/landing'

export const problemCards: ProblemCard[] = [
  {
    id: 'repetitive',
    icon: 'repeat',
    title: 'Same-style worksheets lose attention',
  },
  {
    id: 'planning',
    icon: 'clock',
    title: 'Extra practice takes time to plan',
  },
  {
    id: 'wins',
    icon: 'sparkles',
    title: 'Learners need quick wins',
  },
  {
    id: 'next-step',
    icon: 'compass',
    title: 'Adults need a clear next step',
  },
]
